import { render, staticRenderFns } from "./appointmentDetails.vue?vue&type=template&id=2a7e2828&scoped=true&"
import script from "./appointmentDetails.vue?vue&type=script&lang=js&"
export * from "./appointmentDetails.vue?vue&type=script&lang=js&"
import style0 from "./appointmentDetails.vue?vue&type=style&index=0&id=2a7e2828&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7e2828",
  null
  
)

export default component.exports